/* eslint-disable no-console */

/**
 * @module M/control/SearchSIPOBControl
 */

import SearchSIPOBImplControl from 'impl/searchsipobcontrol';
import template from 'templates/searchsipob';
import templateError from 'templates/searchsipobError';
import templateInformacion from 'templates/searchsipobInformacion';
import Choices from 'choices.js';

export default class SearchSIPOBControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(config) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(SearchSIPOBImplControl)) {
      M.exception('La implementación usada no puede crear controles SearchSIPOBControl');
    }
    // 2. implementation of this control
    const impl = new SearchSIPOBImplControl();
    super(impl, 'SearchSIPOB');
    this.municipios = config.municipios;
    this.provincias = config.provincias;
    this.Group_layers = config.Group_layers;

    this.listProvincias = [];
    this.listMunicipios = [];
    this.fullMunicipios = [];
    this.selectedProvincias = [];
    this.selectedMunicipios = [];
    this.selectedGeometries = new Object();
    this.selectedFeatures = [];
    this.control_fin;
    this.hiddenItems = ['Featureid'];

    this.elemSelected = [];



    //  OBJETO PARA LA TABLA DE ESTADISTICAS

    this.SupJSON = {
      nombre: '',
      sup: '',
      pob_nuc: 0,
      pob_dis: 0,
      num_nucleos: 0,
      children: []
    };
    this.pobNucStatistics = [];
    this.pobDisStatistics = [];

    //    ESTILO REPRESENTACION ZONA SELECCIONADA

    this.Style_SelectedZone = new M.style.Polygon({
      stroke: {
        color: '#43fd1e',
        width: 5
      }
    });

    //  ESTILO DE ELEMENTO RESALTADO

    this.style_select_feature_table = new M.style.Polygon({
      fill: {
        color: '#43fd1e',
        opacity: 0
      },
      stroke: {
        color: '#43fd1e',
        width: 6
      }
    });




    //  GRUPOS DE CAPAS

    this.GroupSelectedZone = new M.layer.LayerGroup({
      id: 'groupSelectedZone',
      title: 'Zona Seleccionada',
      collapsed: true,
      zIndex: 300000,
      children: [],
      order: 0
    }
    );

    this.GroupSIPOB = new M.layer.LayerGroup({
      id: 'PoblacionesDeAndalucia',
      title: 'Poblaciones de Andalucía',
      collapsed: true,
      zIndex: 100000,
      children: [],
      order: 1
    }
    );

    this.GroupINE = new M.layer.LayerGroup({
      id: 'UnidadesPoblacionalesINE',
      title: 'Unidades poblacionales (INE)',
      collapsed: true,
      zIndex: 200000,
      children: [],
      order: 2
    }
    );

    this.DelimTerr = new M.layer.LayerGroup({
      id: 'DelimitacionesTerritoriales',
      title: 'Delimitaciones Territoriales',
      collapsed: true,
      zIndex: 50000,
      children: [],
      order: 3
    }
    );

    this.SeleccionElementos_group = new M.layer.LayerGroup({
      id: 'SeleccionElementosGroup',
      title: 'Seleccion de Elementos',
      collapsed: true,
      zIndex: 400000,
      children: [],
    }
    );

    //  CAPA SELECCION DE ELEMENTOS

    this.SeleccionElementos_layer = new M.layer.GeoJSON({
      name: 'Capa Seleccion de Elementos',
      source: {
        crs: {
          "type": "name",
          "properties": {
            "name": "urn:ogc:def:crs:EPSG::25830"
          }
        },
        features: [],
        type: "FeatureCollection"
      }
    });

    this.control_show_results = new Object();

  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = {};
        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }
        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      const html = M.template.compileSync(template);
      // Añadir código dependiente del DOM
      this.addEvents(html);

      success(html);
    });
  }

  addEvents(html) {
    this.selectProvincias = html.querySelectorAll('select#selectProvincias')[0];
    this.selectMunicipios = html.querySelectorAll('select#selectMunicipios')[0];
    this.loadButton = html.querySelectorAll('button#loadButton')[0];
    this.clearButton = html.querySelectorAll('button#clearButton')[0];
    this.totNucText = html.querySelectorAll('td#totNucText')[0];
    this.totNucDat = html.querySelectorAll('td#totNucDat')[0];
    this.pobTot = html.querySelectorAll('td#pobTot')[0];
    this.Sup = html.querySelectorAll('td#Sup')[0];
    this.porcHabNuc = html.querySelectorAll('td#porcHabNuc')[0];
    this.porcHabDis = html.querySelectorAll('td#porcHabDis')[0];
    this.searchLayers = html.querySelectorAll('div#searchLayers')[0];
    this.pest_results = html.querySelectorAll('label#pest_results')[0];
    this.pest_buscarMunicipio = html.querySelectorAll('label#pest_buscarMunicipio')[0];
    this.filtro = html.querySelectorAll('div#filtro')[0];
    this.results_div = html.querySelectorAll('div#results_div')[0];
    this.results = html.querySelectorAll('div#results')[0];
    this.statistics = html.querySelectorAll('div#statistics')[0];
    this.titleStatistics = html.querySelectorAll('div#titleStatistics')[0];


    this.map_.addLayerGroup(this.SeleccionElementos_group);

    this.SeleccionElementos_layer.setStyle(this.style_select_feature_table);
    this.SeleccionElementos_group.addChildren(this.SeleccionElementos_layer);

    this.map_.addLayerGroup([this.GroupSelectedZone]);
    this.getDataStatistics();


    this.choices_selectProvincias = new Choices(this.selectProvincias, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Provincia', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

    this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });


    this.titleStatistics.addEventListener('click', () => {
      if (this.statistics.style.visibility == 'visible') {
        this.statistics.style.visibility = 'hidden';
        this.titleStatistics.children[0].classList.remove('show');
        this.titleStatistics.children[0].classList.add('hide');
      } else {
        this.statistics.style.visibility = 'visible';
        this.titleStatistics.children[0].classList.remove('hide');
        this.titleStatistics.children[0].classList.add('show');
      }
    });

    this.pest_results.addEventListener('click', () => {
      if (this.pest_buscarMunicipio.classList.contains('actived')) {
        this.pest_buscarMunicipio.classList.remove('actived');
        this.filtro.style.display = 'none';
      }
      this.pest_results.classList.add('actived');
      this.results_div.style.display = 'block';
    });

    this.pest_buscarMunicipio.addEventListener('click', () => {
      if (this.pest_results.classList.contains('actived')) {
        this.pest_results.classList.remove('actived');
        this.results_div.style.display = 'none';
      }
      this.pest_buscarMunicipio.classList.add('actived');
      this.filtro.style.display = 'block';
    });



    this.selectProvincias.addEventListener('change', (evt) => {

      // OCULTAMOS O HACEMOS VISIBLE EL SPAN BAJO CHOICES EN FUNCION DE SU HEIGHT   
      if (this.choices_selectProvincias.containerInner.element.clientHeight > 45) {
        this.choices_selectProvincias.containerInner.element.parentNode.parentNode.lastChild.previousElementSibling.style.display = 'none';
      } else {
        this.choices_selectProvincias.containerInner.element.parentNode.parentNode.lastChild.previousElementSibling.style.display = 'block'
      }


      if (this.choices_selectProvincias.getValue(true).length == 0) {
        this.clearButton.disabled = true;
        this.loadButton.disabled = true;
        this.choices_selectMunicipios.removeActiveItems();
        this.selectedMunicipios = [];
      } else {
        this.clearButton.disabled = false;
        this.loadButton.disabled = false;
      }

      this.selectedProvincias = this.choices_selectProvincias.getValue(true);
      //  si la provincia se elimina comprobamos que no hay ningún municipio seleccionado de esa provincia

      if (!this.selectedProvincias.includes(evt.detail.value)) {
        let index = this.listProvincias.indexOf(evt.detail.value);
        this.selectedMunicipios.forEach((municipio) => {

          if (this.listMunicipios[index].includes(municipio)) {
            this.choices_selectMunicipios.removeActiveItemsByValue(municipio);
            this.selectedMunicipios = this.choices_selectMunicipios.getValue(true);
          }
        });
      }

      // CAMBIAMOS LOS VALORES DE LA TABLA DE ESTADISTICAS
      this.changeStatistics();

      this.choices_selectMunicipios.clearChoices();
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
      // this.choices_selectMunicipios.destroy();
      // this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: this.createSelectOptionsMunicipios(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });
      this.choices_selectMunicipios.setChoiceByValue(this.selectedMunicipios);

      this.selectedMunicipios = this.choices_selectMunicipios.getValue(true);      

    });

    this.selectMunicipios.addEventListener('change', (evt) => {


      // OCULTAMOS O HACEMOS VISIBLE EL SPAN BAJO CHOICES EN FUNCION DE SU HEIGHT
      if (this.choices_selectMunicipios.containerInner.element.clientHeight > 45) {
        this.choices_selectMunicipios.containerInner.element.parentNode.parentNode.lastChild.previousElementSibling.style.display = 'none';
      } else {
        this.choices_selectMunicipios.containerInner.element.parentNode.parentNode.lastChild.previousElementSibling.style.display = 'block'
      }

      if (!this.choices_selectMunicipios.getValue(true).includes(evt.detail.value)) {

        this.selectedMunicipios = this.choices_selectMunicipios.getValue(true);

        this.choices_selectMunicipios.destroy();
        this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: this.createSelectOptionsMunicipios(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });
        this.choices_selectMunicipios.setChoiceByValue(this.selectedMunicipios);

      } else {

        this.selectedMunicipios = this.choices_selectMunicipios.getValue(true);

        for (let mun of this.selectedMunicipios) {
          let muniSel = mun;
          for (let i = 0; i < this.listMunicipios.length; i++) {
            if (this.listMunicipios[i].indexOf(muniSel) != -1) {
              this.choices_selectProvincias.setChoiceByValue(this.listProvincias[i]);
            }
          }
        }

      }

      if (this.choices_selectMunicipios.getValue(true).length == 0) {
        this.clearButton.disabled = true;
        this.loadButton.disabled = true;
      } else {
        this.clearButton.disabled = false;
        this.loadButton.disabled = false;
      }

      this.selectedMunicipios = this.choices_selectMunicipios.getValue(true);
      this.selectedProvincias = this.choices_selectProvincias.getValue(true);

      this.changeStatistics();


    });

    this.loadButton.addEventListener('click', () => {

      let filtered_groups = this.Group_layers.filter(obj => obj.show == true);
      let layers = [];

      if (filtered_groups.length != 0) {
        let templateVars = {
          vars: {
            sipob: [],
            ine: [],
            provincia: null,
            municipio: null
          }
        }
        for (let group of filtered_groups) {

          let filtered_layers = group.layers.filter(obj => obj.show == true);


          for (let i = 0; i < filtered_layers.length; i++) {
            if (group.layer_group == 'PoblacionesDeAndalucia') {
              templateVars.vars.sipob.push(filtered_layers[i].name);
            } else {
              templateVars.vars.ine.push(filtered_layers[i].name);
            }
            layers.push(filtered_layers[i]);
          }
        }

        if (this.selectedMunicipios != 0) {
          templateVars.vars.municipio = this.selectedMunicipios;
          templateVars.vars.provincia = this.selectedProvincias;
        } else {
          templateVars.vars.provincia = this.selectedProvincias;
        }

        this.choices_selectProvincias.disable();
        this.choices_selectMunicipios.disable();
        this.loadButton.disabled = true;
        let htmlInformacion = M.template.compileSync(templateInformacion, templateVars);
        this.searchData_info(htmlInformacion);

        // COMPROBAMOS QUE TODAS LAS PROVINCIAS SELECCIONADAS TIENEN UN MUNICIPIO SELECCIONADO AL MENOS
        // QUITAMOS LAS PROVINCIAS SIN MUNICIPIOS SELECCIONADOS

        if (this.selectedMunicipios.length != 0) {
          this.selectedProvincias = [];
          this.choices_selectProvincias.removeActiveItems();
          for (let mun of this.selectedMunicipios) {
            for (let i = 0; i < this.listMunicipios.length; i++) {
              if (this.listMunicipios[i].indexOf(mun) != -1) {
                this.choices_selectProvincias.setChoiceByValue(this.listProvincias[i]);
              }
            }
          }
          this.selectedProvincias = this.choices_selectProvincias.getValue(true);
        }

        this.searchData(layers);
      } else {
        let templateVars = {
          vars: {
            msgError: "No hay capas seleccionadas.",
          },
        }
        let htmlError = M.template.compileSync(templateError, templateVars);
        M.dialog.error(htmlError.innerHTML);
      }
    });

    this.clearButton.addEventListener('click', () => {
      this.selectedMunicipios = [];
      this.selectedProvincias = [];
      this.selectedFeatures = [];
      this.choices_selectProvincias.enable();
      this.choices_selectMunicipios.enable();
      this.choices_selectProvincias.removeActiveItems();
      this.choices_selectProvincias.destroy();

      this.choices_selectProvincias = new Choices(this.selectProvincias, { allowHTML: true, choices: this.createSelectOptionsProvincias(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Provincia', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });
      this.choices_selectMunicipios.removeActiveItems();
      this.choices_selectMunicipios.destroy();
      this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: this.createSelectOptionsMunicipios(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

      this.statistics.style.visibility = 'visible';

      this.control_show_results = new Object();

      if (this.titleStatistics.children[0].classList.contains('hide')) {
        this.titleStatistics.children[0].classList.remove('hide');
        this.titleStatistics.children[0].classList.add('show');
      }


      this.changeStatistics();
      this.results_div.style.display = 'none';
      if (this.pest_results.classList.contains('actived')) {
        this.pest_results.classList.remove('actived');
        this.pest_buscarMunicipio.classList.add('actived');
      }
      this.pest_results.style.display = 'none';
      this.filtro.style.display = 'block';

      this.loadButton.disabled = true;
      this.clearButton.disabled = true;


      M.dialog.info('<p class="elim">FILTRO DE BÚSQUEDA</p>', 'ELIMINANDO');
      document.querySelectorAll('div.m-dialog.info')[0].classList.add('sipobMessage');



      setTimeout(() => {
        this.clearLayers();
        this.addElementLayer();
        if (document.querySelectorAll('div.m-dialog.info>div.m-modal>div.m-content>div.m-button').length != 0) {
          document.querySelectorAll('div.m-dialog.info>div.m-modal>div.m-content>div.m-button')[0].children[0].click();
        }

      }, 1);

    });



    this.map_.on(M.evt.CLICK, (evt) => {

      if (this.elemSelected.length != 0) {
        this.map_.getFeatureHandler().selectFeatures(this.elemSelected, this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0], { coord: evt.coord });
        let nombCapa = this.elemSelected[0].getImpl().getOLFeature().values_.featureId.split('.')[0];
        switch (nombCapa) {
          case 'd_pob_nucleo_cabecera':
            nombCapa = 'Cabecera Municipal';
            break;
          case 'd_pob_nucleo_secundario':
            nombCapa = 'Núcleo Secundario';
            break;
          case 'd_pob_poblacion_diseminado':
            nombCapa = 'Poblaciones en diseminado';
            break;
          case 'd_pob_edificacion_aislada':
            nombCapa = 'Edificaciones aisladas';
            break;
          case 'd_pob_otro_uso':
            nombCapa = 'Otros usos';
            break;
          case 'd_ine_nucleo':
            nombCapa = 'Núcleos urbanos';
            break;
          case 'd_ine_diseminado':
            nombCapa = 'Diseminados';
            break;
          case 'd_ine_entidad_colectiva':
            nombCapa = 'Entidades colectivas';
            break;
          case 'd_ine_entidad_singular':
            nombCapa = 'Entidades singulares';
            break;
        }

        this.filterPopup(nombCapa);
      }

    });

    this.SeleccionElementos_layer.on(M.evt.HOVER_FEATURES, (feat) => {
      this.elemSelected = feat;

    });

    this.SeleccionElementos_layer.on(M.evt.LEAVE_FEATURES, (feat) => {
      this.elemSelected = [];

    });

    this.panel_.on(M.evt.SHOW, () => {
      this.moveRightTools('show');
    });

    this.panel_.on(M.evt.HIDE, () => {
      this.moveRightTools('hide');
    });





    // AÑADIMOS OBSERVER PARA DETECTAR CAMBIOS EN EL DOM
    // MODIFICAMOS EL ASPECTO DE LOS POPUP AL VUELO.

    const observer = new MutationObserver((mutationList) => {
      if (mutationList[0].target.classList.contains('ol-overlay-container')) {
        // Evitamos overviewmap
        if (!mutationList[0].target.children[0].classList.contains('ol-overviewmap-box')) {
          if (mutationList[0].type === 'attributes') {
            if (!mutationList[0].target.children[0].classList.contains('m-has-tabs')) {
              if (mutationList[0].target.children[0].children[0].children[0].children[0].innerHTML == '') {
                mutationList[0].target.children[0].children[0].children[0].children[0].innerHTML = 'INFORMACIÓN DE';
              }
              let capas = mutationList[0].target.children[0].children[0].children[1].children;



              if (capas[0].children.length != 0 && capas[0].children[0].className != 'm-getfeatureinfo-content') {
                for (let capa of capas) {
                  capa.children[0].children[1].children[0].innerHTML = capa.children[0].children[1].children[0].innerHTML.replace('Información de ', '');
                }

                for (let i = 0; i < capas.length; i++) {
                  let origin = '';
                  switch (capas[i].children[0].children[1].children[0].children[0].innerHTML) {
                    case 'Cabecera Municipal':
                    case 'Núcleo Secundario':
                    case 'Poblaciones en diseminado':
                    case 'Edificaciones aisladas':
                    case 'Otros usos':
                      origin = ' (SIPOB)';
                      break;
                    case 'Núcleos urbanos':
                    case 'Diseminados':
                    case 'Entidades colectivas':
                    case 'Entidades singulares':
                      origin = ' (INE)';
                      break;

                  }
                  if (capas[i].children[0].children[1].children[0].children[0].innerHTML.indexOf('(') == -1) {
                    capas[i].children[0].children[1].children[0].children[0].innerHTML += origin;
                  }
                }
              }
            } else {
              let pestañas = document.querySelectorAll('div.m-tab');
              let nomCapaJSON = this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].getFeatures()[0].getAttributes().featureId.split('.')[0];
              let titleJSON;
              switch (nomCapaJSON) {
                case 'd_pob_nucleo_cabecera':
                  titleJSON = 'Cabecera Municipal';
                  break;
                case 'd_pob_nucleo_secundario':
                  titleJSON = 'Núcleo Secundario';
                  break;
                case 'd_pob_poblacion_diseminado':
                  titleJSON = 'Poblaciones en diseminado';
                  break;
                case 'd_pob_edificacion_aislada':
                  titleJSON = 'Edificaciones aisladas';
                  break;
                case 'd_pob_otro_uso':
                  titleJSON = 'Otros usos';
                  break;
                case 'd_ine_nucleo':
                  titleJSON = 'Núcleos urbanos';
                  break;
                case 'd_ine_diseminado':
                  titleJSON = 'Diseminados';
                  break;
                case 'd_ine_entidad_colectiva':
                  titleJSON = 'Entidades colectivas';
                  break;
                case 'd_ine_entidad_singular':
                  titleJSON = 'Entidades singulares';
                  break;
              }
              let titulo = document.createElement('div');
              titulo.className = 'm-title';
              titulo.textContent = titleJSON;
              document.querySelectorAll('a.m-popup-closer')[0].insertAdjacentElement('beforebegin', titulo);
              for (let pestaña of pestañas) {
                pestaña.addEventListener('click', () => {
                  let tipo = pestaña.children[0].className;
                  if (tipo == 'g-cartografia-info') {
                    pestaña.parentNode.nextElementSibling.querySelectorAll('div.m-title')[0].innerHTML = 'INFORMACIÓN DE';
                  }
                  if (tipo == 'g-cartografia-pin') {
                    pestaña.parentNode.nextElementSibling.querySelectorAll('div.m-title')[0].innerHTML = titleJSON;
                  }
                  console.log(pestaña.parentNode.nextElementSibling.querySelectorAll('div.m-title')[0].innerHTML);
                  if (document.querySelectorAll('div.result')[0]) {
                    this.ocultaElementos();
                  }
                });
              }

              this.ocultaElementos();

            }
          }
        }
      }
    });

    const containerPopup = document.querySelectorAll('div.ol-overlaycontainer-stopevent')[0];
    const observerOptions = {
      attributes: true,
      childList: true,
      subtree: true
    }

    observer.observe(containerPopup, observerOptions);



    this.addElementLayer();

  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    // calls super to manage de/activation
    super.activate();

  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {
    // calls super to manage de/activation
    super.deactivate();

  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-searchsipob button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof SearchSIPOBControl;
  }

  // Add your own functions



  createSelectOptionsProvincias() {
    let selectOptions = new Array();
    for (let prov of this.listProvincias) {
      let option = {
        value: prov,
        label: prov,
        selected: false,
        disbled: false,
      }
      selectOptions.push(option);
    }
    return selectOptions;
  }

  createSelectOptionsMunicipios() {
    let selectOptions = new Array();

    if (this.choices_selectProvincias.getValue(true).length == 0) {
      for (let mun of this.fullMunicipios) {
        let option = {
          value: mun,
          label: mun,
          selected: false,
          disbled: false,
        }
        selectOptions.push(option);
      }
    } else {
      for (let prov of this.choices_selectProvincias.getValue(true)) {
        let index = this.listProvincias.indexOf(prov);
        for (let mun of this.listMunicipios[index]) {
          let option = {
            value: mun,
            label: mun,
            selected: false,
            disbled: false,
          }
          selectOptions.push(option);
        }
      }
    }

    return selectOptions;
  }

  changeStatistics() {
    let site = '';
    let numSite = '';
    let Pob = '';
    let Sup = '';
    let porcNuc = '';
    let porcDis = '';
    let selection;
    if (this.selectedProvincias.length == 0 && this.selectedMunicipios.length == 0) {
      site = this.SupJSON.nombre.toUpperCase();
      numSite = this.SupJSON.num_nucleos;
      Sup = this.SupJSON.sup;
      Pob = this.SupJSON.pob_dis + this.SupJSON.pob_nuc;
      porcNuc = ((this.SupJSON.pob_nuc / Pob) * 100).toFixed(2);
      porcDis = ((this.SupJSON.pob_dis / Pob) * 100).toFixed(2);
    }

    if (this.selectedProvincias.length == 1 && this.selectedMunicipios.length == 0) {
      selection = this.SupJSON.children.filter(obj => obj.nombre == this.selectedProvincias[0])[0];
      site = 'LA PROVINCIA DE ' + selection.nombre.toUpperCase();
      numSite = selection.num_nucleos;
      Sup = selection.sup;
      Pob = selection.pob_dis + selection.pob_nuc;
      porcNuc = ((selection.pob_nuc / Pob) * 100).toFixed(2);
      porcDis = ((selection.pob_dis / Pob) * 100).toFixed(2);
    }

    if (this.selectedMunicipios.length == 1) {
      let index = 0;
      let prov;
      for (let i = 0; i < this.listMunicipios.length; i++) {
        if (this.listMunicipios[i].indexOf(this.selectedMunicipios[0]) != -1) {
          index = i;
        }
      }
      prov = this.listProvincias[index];


      selection = this.SupJSON.children.filter(obj => obj.nombre == prov)[0].children.filter(obj => obj.nombre == this.selectedMunicipios[0])[0];

      site = selection.nombre.toUpperCase() + ' (' + prov.toUpperCase() + ')';
      numSite = selection.num_nucleos;
      Sup = selection.sup;
      Pob = selection.pob_dis + selection.pob_nuc;
      porcNuc = ((selection.pob_nuc / Pob) * 100).toFixed(2);
      porcDis = ((selection.pob_dis / Pob) * 100).toFixed(2);
    }
    if (this.selectedMunicipios.length > 1) {
      site = 'MUNICIPIOS SELECCIONADOS';
      numSite = 0;
      Pob = 0;
      porcNuc = 0;
      porcDis = 0;
      Sup = 0;
      for (let mun of this.selectedMunicipios) {
        for (let i = 0; i < this.selectedProvincias.length; i++) {
          selection = this.SupJSON.children.filter(obj => obj.nombre == this.selectedProvincias[i])[0].children.filter(obj => obj.nombre == mun);
          if (selection.length != 0) {
            numSite += selection[0].num_nucleos;
            Pob = Pob + selection[0].pob_dis + selection[0].pob_nuc;
            porcNuc = porcNuc + selection[0].pob_nuc;
            porcDis = porcDis + selection[0].pob_dis;
            Sup += parseFloat(selection[0].sup);
          }
        }
      }

      Sup = Sup.toFixed(2);
      porcNuc = ((porcNuc / Pob) * 100).toFixed(2);
      porcDis = ((porcDis / Pob) * 100).toFixed(2);
    }

    if (this.selectedProvincias.length > 1 && this.selectedMunicipios.length == 0) {
      site = 'PROVINCIAS SELECCIONADAS';
      numSite = 0;
      Pob = 0;
      porcNuc = 0;
      porcDis = 0;
      Sup = 0;

      for (let i = 0; i < this.selectedProvincias.length; i++) {
        selection = this.SupJSON.children.filter(obj => obj.nombre == this.selectedProvincias[i])[0];

        numSite += selection.num_nucleos;
        Pob = Pob + selection.pob_dis + selection.pob_nuc;
        porcNuc = porcNuc + selection.pob_nuc;
        porcDis = porcDis + selection.pob_dis;
        Sup += parseFloat(selection.sup);

      }

      Sup = Sup.toFixed(2);

      porcNuc = ((porcNuc / Pob) * 100).toFixed(2);
      porcDis = ((porcDis / Pob) * 100).toFixed(2);
    }

    this.totNucText.innerHTML = 'TOTAL DE N&Uacute;CLEOS EN <br>' + site;
    this.totNucDat.innerHTML = new Intl.NumberFormat('de-DE').format(numSite);
    this.pobTot.innerHTML = new Intl.NumberFormat('de-DE').format(Pob) + ' hab.';
    this.porcHabNuc.innerHTML = porcNuc.replace('.', ',') + ' %';
    this.porcHabDis.innerHTML = porcDis.replace('.', ',') + ' %';
    this.Sup.innerHTML = Sup.replace('.', ',') + ' Km²';
  }

  showItem(element) {
    if (element.style.display == 'none') {
      element.previousElementSibling.children[0].innerHTML = '▼' + element.previousElementSibling.children[0].innerHTML.slice(1);
      element.style.display = 'block';
    } else {
      element.previousElementSibling.children[0].innerHTML = '►' + element.previousElementSibling.children[0].innerHTML.slice(1);
      element.style.display = 'none';
    }
  }

  selectItem(element) {

    if (!element.id.includes('div_')) {
      let grupo_Capas = this.Group_layers.filter(function (elemento) { return elemento.layer_group == element.parentElement.id })[0];
      let capa = grupo_Capas.layers.filter(function (elemento) { return elemento.layer == element.id })[0];

      if (element.children[0].className == 'hide') {
        element.children[0].className = 'show';
        capa.show = true;
      } else {
        element.children[0].className = 'hide';
        capa.show = false;
      }
      let check = grupo_Capas.layers.filter(function (elemento) { return elemento.show == true });
      if (check.length == 0) {
        element.parentElement.previousElementSibling.children[0].nextElementSibling.className = 'hide';
        grupo_Capas.show = false;
      } else {
        element.parentElement.previousElementSibling.children[0].nextElementSibling.className = 'show';
        grupo_Capas.show = true;
      }
    } else {
      let grupo_Capas = this.Group_layers.filter(function (elemento) { return elemento.layer_group == element.id.slice(4) })[0];
      if (element.lastChild.className == 'hide') {
        element.lastChild.className = 'show';
        for (let ele of element.nextElementSibling.children) {
          ele.children[0].className = 'show';
        }
        grupo_Capas.show = true;
        for (let ele of grupo_Capas.layers) {
          ele.show = true;
        }
      } else {
        element.lastChild.className = 'hide';
        for (let ele of element.nextElementSibling.children) {
          ele.children[0].className = 'hide';
        }
        grupo_Capas.show = false;
        for (let ele of grupo_Capas.layers) {
          ele.show = false;
        }
      }
    }
  }

  addElementLayer() {
    this.searchLayers.innerHTML = '';
    for (let i = 0; i < this.Group_layers.length; i++) {
      let visibility_group = 'hide';
      if (this.Group_layers[i].show) {
        visibility_group = 'show';
      }
      this.searchLayers.innerHTML += '<div id="div_' + this.Group_layers[i].layer_group + '" class="menu_grupos"><h3 id="' + this.Group_layers[i].layer_group + '">▼      ' + this.Group_layers[i].layer_group_name + '</h3><button class="' + visibility_group + '"></button></div>\n<ul  style="display: block;" id="' + this.Group_layers[i].layer_group + '"></ul>\n';
      let divPadre = this.searchLayers.querySelectorAll('ul#' + this.Group_layers[i].layer_group)[0];
      for (let j = 0; j < this.Group_layers[i].layers.length; j++) {
        let visibility_layer = 'hide';
        if (this.Group_layers[i].layers[j].show) {
          visibility_layer = 'show';
        }

        let text_capa = this.Group_layers[i].layers[j].name;
        if (text_capa.length > 70) {
          text_capa = text_capa.substr(0, 67) + '  . . .';
        }
        divPadre.innerHTML += '<li id="' + this.Group_layers[i].layers[j].layer + '">' + text_capa + '<button class="' + visibility_layer + '"></button></li>\n';
      }
    }
    let elemts = this.searchLayers.querySelectorAll('div#searchLayers h3');
    for (let ele of elemts) {
      ele.addEventListener('click', () => {
        this.showItem(ele.parentElement.nextElementSibling);
      });
      ele.parentElement.lastChild.addEventListener('click', () => {
        this.selectItem(ele.parentElement);
      });

      let btons = ele.parentElement.nextElementSibling.querySelectorAll('button');
      for (let btn of btons) {
        btn.parentElement.addEventListener('click', () => {
          this.selectItem(btn.parentElement);
        });
      }
    }
  }

  showDivResults(boton) {
    this.pest_buscarMunicipio.classList.toggle('actived');
    this.pest_results.classList.add('actived');
    this.pest_results.style.display = 'inline-block';
    this.filtro.style.display = 'none';
    this.results_div.style.display = 'block';
    this.statistics.style.visibility = 'hidden';
    this.titleStatistics.children[0].classList.remove('show');
    this.titleStatistics.children[0].classList.add('hide');
    boton.click();
  }

  AddSelectedZone(source) {
    let layer = new M.layer.GeoJSON({
      name: "Zona Seleccionada",
      source: source,
      extract: false
    });

    layer.options.origen = 'Selección';

    layer.setStyle(this.Style_SelectedZone);

    layer.setLegendURL('leyendas/AreaSeleccionada.png');

    this.map_.getLayerGroup().filter(obj => obj.id == 'groupSelectedZone')[0].addChildren(layer);

    layer.on(M.evt.LOAD, () => {
      let calBBox = layer.getMaxExtent();
      this.map_.setBbox(calBBox);
    });

  }

  AddInitialWMS() {
    this.map_.addLayerGroup([this.GroupSelectedZone, this.GroupSIPOB, this.GroupINE]);

    for (let group of this.Group_layers) {
      let g = this.map_.getLayerGroup().filter(obj => obj.id == group.layer_group)[0];

      for (let layer of group.layers) {
        let style = layer.url.split('sipob:')[1].split('&')[0].slice(2);
        let index = layer.url.indexOf('?');
        let serv = layer.url.slice(0, index).replace('/wfs', '/wms?');
        let capa = layer.url.substring(index);
        index = capa.indexOf(':');
        capa = capa.slice(index + 1);
        index = capa.indexOf('&');
        capa = capa.slice(0, index);
        let l = new M.layer.WMS({
          url: '',
          name: '',
          legend: '',
          transparent: true,
          tiled: false,
          version: '1.3.0'
        }, {
          styles: style
        });

        l.url = serv;
        l.name = capa;
        l.legend = layer.name;

        g.addChildren(l);

        l.on(M.evt.LOAD, () => {
          if (l.getImpl().name == 'd_pob_nucleo_cabecera' || l.getImpl().name == 'd_pob_nucleo_secundario' || l.getImpl().name == 'd_pob_poblacion_diseminado' || l.getImpl().name == 'd_pob_edificacion_aislada' || l.getImpl().name == 'd_pob_otro_uso') {
            l.getImpl().options.origen = 'SIPOB';
          } else {
            l.getImpl().options.origen = 'INE';
          }
          if (l.getImpl().name != 'd_pob_nucleo_cabecera' && l.getImpl().name != 'd_ine_nucleo') {
            l.getImpl().visibility = false;
          }
        });
      }
    }
  }

  viewSelectedWMS() {
    //INICIALIZAMOS EL CONTROL ACTIVELAYERS CON TODAS LAS CAPAS NO VISIBLES Y PONEMOS TODAS LAS CAPAS NO VISIBLES EN EL MAPA
    let control = this.map_.getControls({ name: 'ActiveLayers' })[0];

    for (let layer of control.templateVariables) {

      if (layer.name != 'Zona Seleccionada' && layer.name != 'd_termino_municipal' && layer.groupTitle != 'Otras Capas') {
        layer.visible = false;
      }
    }

    for (let layer of this.map_.getWMS()) {

      if (layer.layerGroup_) {
        if (layer.layerGroup_.id != 'DelimitacionesTerritoriales') {
          if (layer.getImpl().visibility == true) {
            layer.setVisible(false);
          }
        }
      }
    }

    //ACTUALIZAMOS EL CONTROL ACTIVELAYERS CON LAS CAPAS VISIBLES EN GROUP_LAYERS Y LAS PONEMOS VISIBLES EN EL MAPA

    let gruposVisibles = this.Group_layers.filter(obj => obj.show == true);

    let array_cql = [];
    for (let grupo of gruposVisibles) {
      let capasVisibles = grupo.layers.filter(obj => obj.show == true);
      for (let capa of capasVisibles) {
        let elem = capa.url.split('sipob:')[1].split('&')[0];
        switch (elem) {
          case 'd_pob_nucleo_cabecera':
            array_cql.push('cab_mun');
            break;
          case 'd_pob_nucleo_secundario':
            array_cql.push('nuc_sec');
            break;
          case 'd_pob_poblacion_diseminado':
            array_cql.push('pob_dis');
            break;
          case 'd_pob_edificacion_aislada':
            array_cql.push('edi_ais');
            break;
          case 'd_pob_otro_uso':
            array_cql.push('otr_uso');
            break;
          case 'd_ine_nucleo':
            array_cql.push('nuc_ine');
            break;
          case 'd_ine_diseminado':
            array_cql.push('dis_ine');
            break;
          case 'd_ine_entidad_colectiva':
            array_cql.push('ent_col');
            break;
          case 'd_ine_entidad_singular':
            array_cql.push('ent_sin');
            break;
        }
        let layerWMS = this.map_.getWMS().filter(obj => obj.impl_.legend == capa.name)[0];
        if (layerWMS.getImpl().visibility == false) {
          layerWMS.setVisible(true);
          control.templateVariables.filter(obj => obj.title == capa.name)[0].visible = true;
        }
      }
    }

    let cql_chain = 'CQL_FILTER=nivel%20IN%20('
    for (let elem of array_cql) {
      cql_chain += '\'' + elem + '\',';
    }
    cql_chain = cql_chain.slice(0, -1);
    cql_chain += ')';
    let url_layer = this.map_.getWMS({ name: 'd_pob_etiquetas' })[0].getImpl().getOLLayer().getSource().url_.split('CQL_FILTER=')[0];
    this.map_.getWMS({ name: 'd_pob_etiquetas' })[0].getImpl().getOLLayer().getSource().url_ = url_layer + cql_chain;
    this.map_.getWMS({ name: 'd_pob_etiquetas' })[0].refresh();

  }

  clearLayers() {

    let grup = this.map_.getLayerGroup().filter(obj => obj.id == 'groupSelectedZone');

    this.map_.removeLayerGroup(grup);
    this.map_.addLayerGroup(grup);

    let cap_seleccion = this.map_.getGeoJSON().filter(obj => obj.getImpl().name == 'Capa Seleccion de Elementos')[0];

    if (cap_seleccion.getFeatures().length != 0) {
      cap_seleccion.removeFeatures(cap_seleccion.getFeatures());
    }

    if (this.map_.getPopup()) {
      this.map_.removePopup();
    }
    let groupVisible = this.Group_layers.filter(obj => obj.show == true);
    for (let g of groupVisible) {
      let capasVisibles = g.layers.filter(obj => obj.show == true);
      for (let c of capasVisibles) {
        c.show = false;
      }
      g.show = false;
    }
    this.Group_layers[0].show = true;
    this.Group_layers[0].layers[0].show = true;
    this.Group_layers[1].show = true;
    this.Group_layers[1].layers[0].show = true;
    this.viewSelectedWMS();

    this.map_.setMaxExtent(this.map_.getMaxExtent());

  }

  searchData(layers) {
    this.control_fin = layers.length;
    let boton = document.querySelectorAll('div.m-content>div.m-button>button')[0];

    if (this.selectedMunicipios.length != 0) {
      let parametrosBusqueda = "('";
      for (let mun of this.selectedMunicipios) {
        for (let prov of this.SupJSON.children) {
          let find_mun = prov.children.filter(obj => obj.nombre == mun);
          if (find_mun.length != 0) {
            parametrosBusqueda += find_mun[0].cod + "','";
          }
        }
      }
      parametrosBusqueda = parametrosBusqueda.substring(0, parametrosBusqueda.length - 2);
      parametrosBusqueda += ")";

      M.remote.get(encodeURI(this.municipios.url + "&cql_filter=codigo_ine IN " + parametrosBusqueda)).then((res) => {
        let geometryMun = JSON.parse(res.text);
        this.AddSelectedZone(geometryMun);
      });

      for (let i = 0; i < layers.length; i++) {
        M.remote.get(layers[i].url + "&cql_filter=cod_mun%20IN%20" + parametrosBusqueda).then((res) => {
          let resData = JSON.parse(res.text);

          this.ordenarAsc(resData.features, 'nombre_municipio');



          let reg = [];
          let grupo = '';
          let nombreGrupo = '';
          reg.push(layers[i].name);


          if (layers[i].name == 'Cabecera Municipal' || layers[i].name == 'Núcleo Secundario' || layers[i].name == 'Poblaciones en diseminado' || layers[i].name == 'Edificaciones aisladas' || layers[i].name == 'Otros usos') {
            nombreGrupo = 'Poblaciones de Andalucía';
            grupo = 'PoblacionesDeAndalucia';
          } else {
            nombreGrupo = 'Unidades poblacionales (INE)';
            grupo = 'UnidadesPoblacionalesINE';
          }

          reg.push(grupo);
          reg.push(nombreGrupo);

          for (let elem of resData.features) {
            let item = {
              'featureId': elem.id
            };

            this.selectedGeometries[elem.id] = elem.geometry;

            Object.assign(item, elem.properties);

            reg.push(item);

          }
          if (reg.length > 3) {
            this.selectedFeatures.push(reg);
          }

          this.control_fin -= 1;

          if (this.control_fin == 0) {
            this.viewSelectedWMS();
            this.ordenarSelectedFeatures(this.selectedFeatures);
            this.showFeatures_pag();
            this.showDivResults(boton);

          }
        });
      }
    } else {
      let parametrosBusqueda = "('";
      for (let prov of this.selectedProvincias) {
        parametrosBusqueda += prov + "','";
      }
      parametrosBusqueda = parametrosBusqueda.substring(0, parametrosBusqueda.length - 2);
      parametrosBusqueda += ")";


      M.remote.get(encodeURI(this.provincias.url + "&cql_filter=provincia IN " + parametrosBusqueda)).then((res) => {

        let geometryProv = JSON.parse(res.text);
        this.AddSelectedZone(geometryProv);
      });

      parametrosBusqueda = '&cql_filter=';

      for (let i = 0; i < this.selectedProvincias.length; i++) {
        let findProv = this.SupJSON.children.filter(obj => obj.nombre == this.selectedProvincias[i])[0].cod;

        if (i == 0) {
          parametrosBusqueda += "cod_mun LIKE '" + findProv + "%'";
        } else {
          parametrosBusqueda += " OR cod_mun LIKE '" + findProv + "%'";
        }
      }



      for (let i = 0; i < layers.length; i++) {
        M.remote.get(encodeURI(layers[i].url + parametrosBusqueda)).then((res) => {

          let resData = JSON.parse(res.text);

          this.ordenarAsc(resData.features, 'nombre_provincia');



          let reg = [];
          let grupo = '';
          let nombreGrupo = '';
          reg.push(layers[i].name);


          if (layers[i].name == 'Cabecera Municipal' || layers[i].name == 'Núcleo Secundario' || layers[i].name == 'Poblaciones en diseminado' || layers[i].name == 'Edificaciones aisladas' || layers[i].name == 'Otros usos') {
            nombreGrupo = 'Poblaciones de Andalucía';
            grupo = 'PoblacionesDeAndalucia';
          } else {
            nombreGrupo = 'Unidades poblacionales (INE)';
            grupo = 'UnidadesPoblacionalesINE';
          }

          reg.push(grupo);
          reg.push(nombreGrupo);

          for (let elem of resData.features) {
            let item = {
              'featureId': elem.id
            };

            this.selectedGeometries[elem.id] = elem.geometry;

            Object.assign(item, elem.properties);

            reg.push(item);

          }
          if (reg.length > 3) {
            this.selectedFeatures.push(reg);
          }

          this.control_fin -= 1;

          if (this.control_fin == 0) {
            this.viewSelectedWMS();
            this.ordenarSelectedFeatures(this.selectedFeatures);
            this.showFeatures_pag();
            this.showDivResults(boton);
          }
        });
      }
    }

  }

  searchData_info(templateVars) {
    let chain = 'CONSULTANDO DATOS DE ';
    if (this.selectedProvincias.length == 1) {
      if (this.selectedMunicipios.length == 1) {
        chain += this.selectedMunicipios[0] + ' (' + this.selectedProvincias[0] + ')';
      }
      if (this.selectedMunicipios.length == 0) {
        chain += 'LA PROVINCIA DE ' + this.selectedProvincias[0];
      }
      if (this.selectedMunicipios.length > 1) {
        chain += 'MUNICIPIOS SELECCIONADOS DE LA PROVINCIA DE ' + this.selectedProvincias[0];
      }
    } else {
      chain += 'LA ZONA SELECCIONADA';
    }

    chain = chain.toUpperCase();
    M.dialog.info(templateVars.innerHTML, chain);
    document.querySelectorAll('div.m-dialog.info')[0].classList.add('sipobMessage');
  }

  getDataStatistics() {
    M.remote.get('https://www.juntadeandalucia.es/intranet/admin/rest/v1.0/consulta/28867').then((res) => {
      let resSuperficies = JSON.parse(res.text);
      let data = resSuperficies.data;

      for (let dat of data) {
        if (dat[0].cod.length == 1) {
          this.SupJSON.nombre = dat[0].des;
          dat[2].format = dat[2].format.replace('.', '');
          this.SupJSON.sup = dat[2].format.replace(',', '.');
        }
        if (dat[0].cod.length == 2) {
          let prov = {
            cod: '',
            nombre: '',
            sup: '',
            pob_nuc: 0,
            pob_dis: 0,
            num_nucleos: 0,
            children: []
          }
          prov.cod = dat[0].cod[dat[0].cod.length - 1];
          prov.nombre = dat[0].des;
          dat[2].format = dat[2].format.replace('.', '');
          prov.sup = dat[2].format.replace(',', '.');
          this.SupJSON.children.push(prov);
        }
        if (dat[0].cod.length == 3) {
          let mun = {
            cod: '',
            nombre: '',
            sup: '',
            pob_nuc: 0,
            pob_dis: 0,
            num_nucleos: 0,
          }
          mun.cod = dat[0].cod[dat[0].cod.length - 1];
          mun.nombre = dat[0].des;
          dat[2].format = dat[2].format.replace('.', '');
          mun.sup = dat[2].format.replace(',', '.');
          let p = this.SupJSON.children.filter(obj => obj.cod == dat[0].cod[dat[0].cod.length - 2]);
          p[0].children.push(mun);
        }
      }


      let ruta_nucleos = this.Group_layers.filter(obj => obj.layer_group == 'UnidadesPoblacionalesINE')[0].layers.filter(obj => obj.layer == 'NucleosUrbanos')[0].url;


      M.remote.get(encodeURI(ruta_nucleos + '&propertyName=cod_mun,poblacion_tot,nombre_provincia')).then((res) => {
        let resNuc = JSON.parse(res.text);
        let data = resNuc.features;
        this.SupJSON.num_nucleos = data.length;
        for (let provincia of this.SupJSON.children) {
          provincia.num_nucleos = data.filter(obj => obj.properties.nombre_provincia == provincia.nombre).length;
          for (let mun of provincia.children) {
            mun.num_nucleos = data.filter(obj => obj.properties.cod_mun == mun.cod).length;
          }
        }

        for (let dat of data) {
          let ele = this.pobNucStatistics.filter(obj => obj.cod_mun == dat.properties.cod_mun);

          if (ele.length == 0) {
            let pob = {
              cod_mun: dat.properties.cod_mun,
              poblaNuc: dat.properties.poblacion_tot
            }
            this.pobNucStatistics.push(pob);
          } else {
            ele[0].poblaNuc += dat.properties.poblacion_tot;
          }
        }
        let pob_And = 0;
        for (let prov of this.SupJSON.children) {
          let pob_total = 0;
          for (let mun of prov.children) {
            if (this.pobNucStatistics.filter(obj => obj.cod_mun == mun.cod).length != 0) {
              mun.pob_nuc = this.pobNucStatistics.filter(obj => obj.cod_mun == mun.cod)[0].poblaNuc;
              pob_total += mun.pob_nuc;
            }
          }
          prov.pob_nuc = pob_total;
          pob_And += prov.pob_nuc;
        }
        this.SupJSON.pob_nuc = pob_And;

        let ruta_diseminados = this.Group_layers.filter(obj => obj.layer_group == 'UnidadesPoblacionalesINE')[0].layers.filter(obj => obj.layer == 'Diseminados')[0].url;

        M.remote.get(encodeURI(ruta_diseminados + '&propertyName=cod_mun,poblacion_tot')).then((res) => {
          let resDis = JSON.parse(res.text);
          let data = resDis.features;
          for (let dat of data) {
            let ele = this.pobDisStatistics.filter(obj => obj.cod_mun == dat.properties.cod_mun);
            if (ele.length == 0) {
              let pob = {
                cod_mun: dat.properties.cod_mun,
                poblaDis: dat.properties.poblacion_tot
              }
              this.pobDisStatistics.push(pob);
            } else {
              ele[0].poblaDis += dat.properties.poblacion_tot;
            }
          }
          let pob_And = 0;
          for (let prov of this.SupJSON.children) {
            let pob_total = 0;
            for (let mun of prov.children) {
              if (this.pobDisStatistics.filter(obj => obj.cod_mun == mun.cod).length != 0) {
                mun.pob_dis = this.pobDisStatistics.filter(obj => obj.cod_mun == mun.cod)[0].poblaDis;
                pob_total += mun.pob_dis;
              }
            }
            prov.pob_dis = pob_total;
            pob_And += prov.pob_dis;
          }
          this.SupJSON.pob_dis = pob_And;

          this.totNucText.innerHTML = 'TOTAL DE N&Uacute;CLEOS EN <br>' + this.SupJSON.nombre.toUpperCase();
          this.totNucDat.innerHTML = new Intl.NumberFormat('de-DE').format(this.SupJSON.num_nucleos);
          this.Sup.innerHTML = this.SupJSON.sup + ' Km²';
          this.pobTot.innerHTML = new Intl.NumberFormat('de-DE').format(this.SupJSON.pob_dis + this.SupJSON.pob_nuc) + ' hab.';
          this.porcHabNuc.innerHTML = ((this.SupJSON.pob_nuc / (this.SupJSON.pob_dis + this.SupJSON.pob_nuc)) * 100).toFixed(2) + ' %';
          this.porcHabDis.innerHTML = ((this.SupJSON.pob_dis / (this.SupJSON.pob_dis + this.SupJSON.pob_nuc)) * 100).toFixed(2) + ' %';



          for (let p of this.SupJSON.children) {
            this.listProvincias.push(p.nombre);
            let arrayP = [];
            for (let m of p.children) {
              arrayP.push(m.nombre);
              this.fullMunicipios.push(m.nombre);
            }
            this.listMunicipios.push(arrayP);
          }
          this.fullMunicipios.sort();

          this.selectProvincias.disabled = false;
          this.selectMunicipios.disabled = false;
          this.choices_selectProvincias.destroy();
          this.choices_selectProvincias = new Choices(this.selectProvincias, { allowHTML: true, choices: this.createSelectOptionsProvincias(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Provincia', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });
          this.choices_selectMunicipios.destroy();
          this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: this.createSelectOptionsMunicipios(), closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Click para seleccionar', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

        });
      });

    });

  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data, geo;

    var wktGeometry

    let addWKTGeometry = this.addWKTGeometry;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ';';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    if (keys.includes('layerName')) { keys.remove('layerName') }
    if (keys.includes('featureId')) { keys.remove('featureId') }

    result = '';
    result += keys.join(columnDelimiter);
    result += columnDelimiter + 'WKT';
    result += lineDelimiter;



    data.forEach((item) => {

      ctr = 0;
      keys.forEach((key) => {
        if (key != 'layerName' && key != 'featureId') {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        }
      });
      geo = this.selectedGeometries[item.featureId];
      wktGeometry = addWKTGeometry(geo.type, geo.coordinates);

      result += columnDelimiter + wktGeometry;

      result += lineDelimiter;
    });

    return result;
  }

  downloadCSV(args) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
      data: args.data
    });
    if (csv == null) return;

    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }


  addWKTGeometry(type, coordinates) {
    let geometry = type.toUpperCase();

    if (type == 'MultiPolygon') {
      geometry += '((';
      coordinates.forEach((pol) => {
        geometry += '(';
        pol.forEach((coord) => {
          coord.forEach((punto) => {
            geometry += punto[0] + ' ' + punto[1] + ',';
          });
          geometry = geometry.slice(0, -1) + '),';
        });
      });
      geometry = geometry.slice(0, -1) + '))';
    }

    return geometry;
  }

  showFeatures_pag() {
    this.results.innerHTML = '';
    if (this.selectedFeatures.length == 0) {
      this.results.innerHTML += '<div id="noResults"> El filtro aplicado no devuelve ningún resultado</div>';
    } else {
      for (let i = 0; i < this.selectedFeatures.length; i++) {
        let ident = '';
        switch (this.selectedFeatures[i][0]) {
          case 'Cabecera Municipal':
            ident = 'Cab_mun_div';
            break;
          case 'Nucleo Secundario':
            ident = 'Nuc_sec_div';
            break;
          case 'Poblaciones en diseminado':
            ident = 'Pob_dis_div';
            break;
          case 'Edificaciones aisladas':
            ident = 'Edi_ais_div';
            break;
          case 'Otros usos':
            ident = 'Otr_uso_div';
            break;
          case 'Núcleos urbanos':
            ident = 'Nuc_urb_div';
            break;
          case 'Diseminados':
            ident = 'Dis_div';
            break;
          case 'Entidades colectivas':
            ident = 'Ent_col_div';
            break;
          case 'Entidades singulares':
            ident = 'Ent_sin_div';
            break;
        }

        let title = 'title_' + i;
        if (typeof this.control_show_results[title] === 'undefined') {
          this.control_show_results[title] = 'hidden';
        }
        let items = this.selectedFeatures[i].length - 3;

        if (!document.querySelectorAll('div#' + this.selectedFeatures[i][1])[0]) {
          this.results.innerHTML += '<div class="grupoCapas" id="' + this.selectedFeatures[i][1] + '"><h3>' + this.selectedFeatures[i][2] + '</h3></div>';
        }
        let grupoCapas = document.querySelectorAll('div#' + this.selectedFeatures[i][1])[0];

        let vis = this.control_show_results[title];


        let sim_vis;
        if (vis == 'hidden') {
          sim_vis = '&#9658&nbsp;'
        } else {
          sim_vis = '&#9660&nbsp;'
        }

        grupoCapas.innerHTML += '<div class="layerName ' + ident + '"><h3 id="' + title + '" class="titulo_resultado">' + sim_vis + this.selectedFeatures[i][0] + ' (' + items + ' resultados)</h3><button class="downLoadCSV m-tool-button g-cartografia-descargar" data-id=' + i + ' alt="Descargar ' + this.selectedFeatures[i][0] + ' en formato CSV" title="Descargar ' + this.selectedFeatures[i][0] + ' (Formato CSV)"></button></div>';

        let groupInformation = this.selectedFeatures[i][1];

        for (let j = 3; j < this.selectedFeatures[i].length; j++) {
          let featureId;

          let cadena = '<table id=tab' + i + '_' + j + ' class="' + title + ' ' + vis + ' ' + ident + '" >\n<tbody>\n';
          Object.entries(this.selectedFeatures[i][j]).forEach(([key, value]) => {
            if (groupInformation == 'PoblacionesDeAndalucia') {
              if (key != 'featureId' && key != 'nuc_id' && key != 'dis_id' && key != 'nivel' && key != 'cod_mun') {
                cadena += '<tr>\n<th>' + key + '</th>\n<td>' + value + '</td>\n</tr>\n';
              } else {
                if (key == 'featureId') {
                  featureId = value;
                }
              }
            } else {
              if (key != 'featureId' && key != 'nivel' && key != 'poblacion_tot' && key != 'cod_mun') {
                cadena += '<tr>\n<th>' + key + '</th>\n<td>' + value + '</td>\n</tr>\n';
              } else {
                if (key == 'featureId') {
                  featureId = value;
                }
              }
            }
          });
          cadena += '</tbody>\n</table>\n';
          grupoCapas.innerHTML += cadena;
          document.getElementById('tab' + i + '_' + j).dataset.featureId = featureId;
        }
      }

      document.querySelectorAll('.titulo_resultado').forEach(el => {
        el.addEventListener('click', e => {
          let id = e.target.getAttribute('id');
          if (this.control_show_results[id] == 'hidden') {
            Object.entries(this.control_show_results).forEach(([key, value]) => {
              if (value == 'shown') {
                value = 'hidden';
                console.log(key);
                document.getElementById(key).innerHTML = '&#9658;' + document.getElementById(key).innerHTML.slice(1);
                document.querySelectorAll('.' + key).forEach(table => {
                  table.classList.remove('show');
                  table.classList.add('hidden');
                });
              }

            });
            this.control_show_results[id] = 'shown';
            document.getElementById(id).innerHTML = '&#9660;' + document.getElementById(id).innerHTML.slice(1);
          } else {
            this.control_show_results[id] = 'hidden';
            document.getElementById(id).innerHTML = '&#9658;' + document.getElementById(id).innerHTML.slice(1);
          }

          document.querySelectorAll('.' + id).forEach(table => {
            if (table.classList.contains('show')) {
              table.classList.remove('show');
              table.classList.add('hidden');
            } else {
              table.classList.remove('hidden');
              table.classList.add('show');
            }
          });

        });
      });

      document.querySelectorAll('.layerName').forEach(el => {
        let buttonElement = el.getElementsByTagName('button')[0]
        buttonElement.addEventListener('click', (evt) => {
          let id = evt.target.dataset.id
          let features = this.selectedFeatures[id];
          let arrayFeatures = []
          let filename
          for (let index = 0; index < features.length; index++) {
            if (index == 0) {
              filename = features[0]
            } else {
              arrayFeatures.push(features[index])
            }
          }
          this.downloadCSV({ filename: filename + ".csv", data: arrayFeatures.slice(2) })
        })
      });



      for (let tabla of document.querySelectorAll('div#results>div>table')) {
        tabla.addEventListener('click', () => {

          if (document.querySelectorAll('div#results>div>table.active')[0]) {
            document.querySelectorAll('div#results>div>table.active')[0].classList.remove('active');
          }
          tabla.classList.add('active');

          if (this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].getFeatures()[0]) {
            this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].removeFeatures(this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].getFeatures()[0]);
          }

          let geometria = this.selectedGeometries[tabla.dataset.featureId];
          let elemts = this.selectedFeatures.filter(obj => obj[1] == tabla.parentNode.id);
          let properties;
          let nameCapa;
          for (let elem of elemts) {
            if (elem.filter(obj => obj.featureId == tabla.dataset.featureId).length != 0) {
              properties = elem.filter(obj => obj.featureId == tabla.dataset.featureId)[0];
              nameCapa = elem[0];
            }
          }

          var feature = new M.Feature("feature", {
            "type": "Feature",
            "id": "feature_selected",
            "geometry": geometria,
            "geometry_name": "geometry",
            "properties": properties
          });

          this.SeleccionElementos_layer.addFeatures([feature]);
          let centroide = this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].getFeatures()[0].getCentroid().getGeometry().coordinates;
          let coord_feature = this.adjustCentroid(centroide, geometria.coordinates, geometria.type);

          if (this.map_.getPopup()) {
            this.map_.removePopup();
          }

          this.map_.getFeatureHandler().selectFeatures([feature], this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0], { coord: coord_feature });


          this.filterPopup(nameCapa);

          //OBTENEMOS EL NIVEL DE ZOOM  DEL ELEMENTO


          this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].calculateMaxExtent().then((obj) => {
            this.map_.setBbox(obj);
            this.map_.setCenter({
              x: coord_feature[0],
              y: coord_feature[1],
              draw: false
            });
          });

        });

      }
    }
  }

  ocultaElementos() {

    let tablas = document.querySelectorAll('div.result')[0].children;
    for (let tabla of tablas) {
      if (this.hiddenItems.includes(tabla.firstElementChild.firstElementChild.firstElementChild.innerHTML.toLowerCase()) || this.hiddenItems.includes(tabla.firstElementChild.firstElementChild.firstElementChild.innerHTML)) {
        tabla.style.display = 'none';
      }
    }

  }



  filterPopup(layer) {
    this.map_.getPopup().getTabs()[0].title = layer;
    this.map_.getPopup().update();
    this.ocultaElementos();
  }

  ordenarAsc(p_array_json, p_key) {
    p_array_json.sort(function (a, b) {
      return (a.properties[p_key] < b.properties[p_key]) ? -1 : (a.properties[p_key] > b.properties[p_key]) ? 1 : 0;
    });
  }

  ordenarSelectedFeatures(p_array) {
    p_array.sort(function (a, b) {
      return (a[1] < b[1]) ? -1 : (a[1] > b[1]) ? 1 : 0;
    });
  }

  adjustCentroid(centroid, poligon, tipo) {
    let borders = this.getBorders(centroid, poligon, tipo);
    if (borders === null) {
      let minX = null;
      let minY = null;
      let maxX = null;
      let maxY = null;
      let pseudoCent;
      for (let punto of poligon[0][0]) {
        if (minX == null || minX > punto[0]) { minX = punto[0]; }
        if (minY == null || minY > punto[1]) { minY = punto[1]; }
        if (maxX == null || maxX < punto[0]) { maxX = punto[0]; }
        if (maxY == null || maxY < punto[1]) { maxY = punto[1]; }
      }
      pseudoCent = [(maxX + minX) / 2, (maxY + minY) / 2];
      borders = this.getBorders(pseudoCent, [poligon[0]], tipo);
      centroid = pseudoCent;
    }

    let status = this.compTopology(borders);

    //  SI EL CENTROIDE ESTA FUERA CORREGIMOS A LA POSICION DENTRO DEL POLIGONO MAS CERCANA AL CENTROIDE Y CON UNA COORDENADA Y IGUAL A LA DEL CENTROIDE
    if (!status) {
      let dist;
      let index;
      for (let i = 0; i < borders.length; i++) {
        if (i == 0) {
          dist = Math.abs(borders[i].coord[0] - centroid[0]);
          index = i;
        } else {
          if (dist > Math.abs(borders[i].coord[0] - centroid[0])) {
            dist = Math.abs(borders[i].coord[0] - centroid[0]);
            index = i;
          }
        }
      }


      if (borders.length != 2) {
        //  SI LA FRONTERA MAS PROXIMA ES LA ULTIMA REALIZAMOS LA OPERACION CON LA ANTERIOR PARA PODER CONSEGUIR INDEX+1
        if (index == borders.length - 1) {
          index -= 1;
        }
        if (borders[index].type == borders[index + 1].type) {
          centroid[0] = (borders[index].coord[0] + borders[index + 1].coord[0]) / 2;
          centroid[1] = borders[index].coord[1];
        } else {
          centroid[0] = (borders[index].coord[0] + borders[index - 1].coord[0]) / 2;
          centroid[1] = borders[index].coord[1];
        }
      } else {
        centroid[0] = (borders[0].coord[0] + borders[1].coord[0]) / 2;
        centroid[1] = borders[0].coord[1];
      }
    }
    return centroid;
  }

  getBorders(centroid, poligono_total, tipo) {

    let array_fronteras = [];

    if (tipo == 'MultiPolygon') {
      for (let i = 0; i < poligono_total.length; i++) {
        for (let t = 0; t < poligono_total[i].length; t++) {
          let fron = this.calculateBorders(centroid, poligono_total[i][t]);
          for (let f of fron) {
            array_fronteras.push(f);
          }
        }
      }
      if (array_fronteras.length == 0) {
        return null;
      }

      array_fronteras.sort((x, y) => x.coord[0] - y.coord[0]);
      return array_fronteras;
    }
    if (tipo == 'Polygon') {
      if (poligono_total.length > 1) {
        for (let i = 0; i < poligono_total.length; i++) {
          let fron = this.calculateBorders(centroid, poligono_total[i]);
          for (let f of fron) {
            array_fronteras.push(f);
          }
        }

      } else {
        let fron = this.calculateBorders(centroid, poligono_total[0]);
        for (let f of fron) {
          array_fronteras.push(f);
        }
      }
      array_fronteras.sort((x, y) => x.coord[0] - y.coord[0]);
      return array_fronteras;
    }
  }

  compTopology(array_fronteras) {
    let estaDentro;
    let der = array_fronteras.filter(obj => obj.type == 'derecha').length;
    let izq = array_fronteras.filter(obj => obj.type == 'izquierda').length;

    // SI LAS FRONTERAS A DERECHA E IZQUIERDA SON PARES EL CENTROIDE ESTÁ FUERA DEL POLÍGONO
    // SI LAS FRONTERAS A DERECHA E IZQUIERDA SON IMPARES EL DENTROIDE ESTÁ DENTRO DEL POLÍGONO

    if (der % 2 == 0 && izq % 2 == 0) {
      estaDentro = false;
    } else {
      estaDentro = true;
    }
    return estaDentro;
  }

  calculateBorders(centroid, poligon) {
    let array_fronteras = [];
    for (let i = 1; i < poligon.length; i++) {
      // CALCULAMOS LAS INTERSECCIONES CON LA RECTA HORIZONTAL QUE PASA POR EL CENTROIDE Y SI ESTÁN A DERECHA O IZQUIERDA DEL CENTROIDE
      if (poligon[i][1] < centroid[1] && poligon[i - 1][1] > centroid[1]) {
        let frontera = new Object();
        frontera.coord = [];
        let coordX = (((poligon[i - 1][0] - poligon[i][0]) / (poligon[i - 1][1] - poligon[i][1])) * (centroid[1] - poligon[i][1])) + poligon[i][0];
        frontera.coord.push(coordX);
        frontera.coord.push(centroid[1]);

        if (centroid[0] > coordX) {
          frontera.type = 'izquierda';
        } else {
          frontera.type = 'derecha';
        }
        array_fronteras.push(frontera);
      }
      if (poligon[i][1] > centroid[1] && poligon[i - 1][1] < centroid[1]) {
        let frontera = new Object();
        frontera.coord = [];
        let coordX = (((poligon[i - 1][0] - poligon[i][0]) / (poligon[i - 1][1] - poligon[i][1])) * (centroid[1] - poligon[i][1])) + poligon[i][0];
        frontera.coord.push(coordX);
        frontera.coord.push(centroid[1]);
        if (centroid[0] > coordX) {
          frontera.type = 'izquierda';
        } else {
          frontera.type = 'derecha';
        }
        array_fronteras.push(frontera);
      }
    }
    return array_fronteras;
  }

  moveRightTools(option) {

    let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0];

    let buttonExten = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

    let mapInfo = document.querySelectorAll('div.m-panel.m-map-info.m-with-overview.opened.no-collapsible.m-with-scale.m-with-mouse')[0];
    let mapMini = document.querySelectorAll('div.ol-overviewmap.ol-unselectable.ol-control')[0];

    let mapMiniButtonClose = mapMini.querySelectorAll('button')[0];

    let location = document.querySelectorAll('div.m-panel.m-location.opened.no-collapsible')[0];

    let attributions = document.querySelectorAll('div.m-panel.m-attributions.clasePrivada')[0];

    if (option == 'show') {


      // MODIFICAMOS POSICION DE GETFEATURE INFO 
      let colorButtonInfo = buttonInfo.style.color;
      if (!colorButtonInfo) {
        colorButtonInfo = '#fff !important';
      }

      buttonInfo.style.cssText = 'color:' + colorButtonInfo + '; margin-right:510px; margin-top: 0px; border-bottom-right-radius:0px; border-top-right-radius:0px; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';
      this.map_.getControls({ name: 'getfeatureinfo' })[0].on(M.evt.DEACTIVATED, () => {
        buttonInfo.style.cssText = 'color: #fff !important; margin-right:510px; margin-top: 0px; border-bottom-right-radius:0px; border-top-right-radius:0px; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';
      });

      // MODIFICAMOS POSICION DE ZOOM EXTENSION 
      // Situamos zoom extensión a la altura selección municipio-provincia

      buttonExten.style.cssText = 'margin-right:510px; margin-top:' + (window.innerHeight - 105) * (-1) + 'px; border-bottom-right-radius:0px; border-top-right-radius:0px; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';
      buttonExten.children[1].children[0].children[0].style.cssText = 'color: #fff;';


      // MODIFICAMOS POSICION DE MAPINFO
      mapInfo.style.cssText = 'margin-right:510px;';

      mapMini.style.cssText = 'margin-bottom:41px; border-bottom-right-radius:0px !important; border-top-right-radius:0px !important; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';

      if (mapMiniButtonClose.className == 'g-cartografia-mundo') {
        mapMiniButtonClose.style.cssText = 'top:146px; color:#fff !important;';
      } else {
        mapMiniButtonClose.style.cssText = 'top:146px; color:#00897b !important;';
      }

      // Cambiamos el color del boton cuando se abra el mapa y cuando se cierre

      mapMiniButtonClose.addEventListener('click', () => {
        if (!this.panel_.isCollapsed()) {
          if (mapMiniButtonClose.className == 'g-cartografia-mundo') {
            mapMiniButtonClose.style.cssText = 'top:146px; color:#fff !important;';
          } else {
            mapMiniButtonClose.style.cssText = 'top:146px; color:#00897b !important;';
          }
        }
      });


      // MODIFICAMOS POSICION DE LOCATION

      location.style.cssText = 'margin-right:510px; margin-bottom:0px; border-bottom-right-radius:0px !important; border-top-right-radius:0px !important; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;'

      location.children[1].children[0].children[0].style.cssText = 'color:#fff !important;';

      //  Mantenemos el color rojo del boton al activarlo

      this.map_.getControls({ name: 'location' })[0].on(M.evt.ACTIVATED, () => {
        location.children[1].children[0].children[0].style.color = null;
      });
      this.map_.getControls({ name: 'location' })[0].on(M.evt.DEACTIVATED, () => {
        if (!this.panel_.isCollapsed()) {
          location.children[1].children[0].children[0].style.cssText = 'color:#fff !important;';
        }
      });
      // MODIFICAMOS POSICION DE ATTRIBUTIONS

      if (this.map_.getControls({ name: 'Attributions' })[0].getPanel().isCollapsed()) {
        attributions.style.cssText = 'margin-right:510px; margin-bottom:0px; border-bottom-right-radius:0px !important; border-top-right-radius:0px !important; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';
      } else {
        attributions.style.cssText = 'margin-right:520px; margin-bottom:0px; border-bottom-right-radius:0px !important; border-top-right-radius:0px !important;';
      }

      attributions.children[0].style.cssText = 'color: #fff; background-color: #00897b !important;';


      this.map_.getControls({ name: 'Attributions' })[0].getPanel().on(M.evt.SHOW, () => {
        attributions.style.background = null;
        attributions.style.borderTop = null;
        attributions.style.borderLeft = null;
        if (!this.panel_.isCollapsed()) {
          attributions.style.cssText = 'margin-right:520px;';
        }

      });
      this.map_.getControls({ name: 'Attributions' })[0].getPanel().on(M.evt.HIDE, () => {
        if (!this.panel_.isCollapsed()) {
          attributions.style.cssText = 'margin-right:510px; margin-bottom:0px; border-bottom-right-radius:0px !important; border-top-right-radius:0px !important; background-color: #00897b !important; border-top:1px solid #00897b; border-left:1px solid #00897b;';

        }
      });

    }

    if (option == 'hide') {
      // RESTAURAMOS POSICION DE GETFEATURE INFO 
      if (buttonInfo.style.color == 'rgb(64, 64, 64)') {
        buttonInfo.style.color = null;
      }
      this.map_.getControls({ name: 'getfeatureinfo' })[0].on(M.evt.DEACTIVATED, () => {
        buttonInfo.style.color = null;
        buttonInfo.style.marginTop = null;
        buttonInfo.style.marginRight = null;
        buttonInfo.style.borderBottomRightRadius = null;
        buttonInfo.style.borderTopLeftRadius = null;
        buttonInfo.style.borderTopRightRadius = null;
        buttonInfo.style.backgroundColor = null;
        buttonInfo.style.borderTop = null;
        buttonInfo.style.borderLeft = null;
      });
      buttonInfo.style.marginTop = null;
      buttonInfo.style.marginRight = null;
      buttonInfo.style.borderBottomRightRadius = null;
      buttonInfo.style.borderTopLeftRadius = null;
      buttonInfo.style.borderTopRightRadius = null;
      buttonInfo.style.backgroundColor = null;
      buttonInfo.style.borderTop = null;
      buttonInfo.style.borderLeft = null;

      // RESTAURAMOS POSICION DE ZOOM EXTENSION

      buttonExten.style.marginRight = null;
      buttonExten.style.marginTop = null;
      buttonExten.style.borderBottomRightRadius = null;
      buttonExten.style.borderTopLeftRadius = null;
      buttonExten.style.borderTopRightRadius = null;
      buttonExten.style.backgroundColor = null;
      buttonExten.style.borderTop = null;
      buttonExten.style.borderLeft = null;
      buttonExten.children[1].children[0].children[0].style.color = null;

      // RESTAURAMOS POSICION DE MAPINFO

      mapInfo.style.marginRight = null;
      mapMini.style.marginBottom = null;
      mapMini.style.borderBottomRightRadius = null;
      mapMini.style.borderBottomLeftRadius = null;
      mapMini.style.borderTopRightRadius = null;
      mapMini.style.backgroundColor = null;
      mapMini.style.borderTop = null;
      mapMini.style.borderLeft = null;
      mapMiniButtonClose.style.top = null;
      mapMiniButtonClose.style.color = null;

      // RESTAURAMOS POSICION DE LOCATION

      location.style.color = null;
      location.style.marginRight = null;
      location.style.marginBottom = null;
      location.style.borderBottomRightRadius = null;
      location.style.borderBottomLeftRadius = null;
      location.style.borderTopRightRadius = null;
      location.style.backgroundColor = null;
      location.style.borderTop = null;
      location.style.borderLeft = null;
      location.children[1].children[0].children[0].style.color = null;

      // RESTAURAMOS POSICION DE ATTRIBUTIONS    

      attributions.style.marginRight = null;
      attributions.style.marginBottom = null;
      attributions.style.borderBottomRightRadius = null;
      attributions.style.borderBottomLeftRadius = null;
      attributions.style.borderTopRightRadius = null;

      attributions.style.backgroundColor = null;
      attributions.style.borderTop = null;
      attributions.style.borderLeft = null;
      attributions.children[0].style.background = null;
      attributions.children[0].style.color = null;
    }
  }
}
